import { computed } from "vue";
import type { TopBar } from "~/types/storyblok/storyblok";
import { resolveLipscoreCountry } from "~/utils/lipscore/loadLipscoreScript";

/**
 * Lipscore widget language for every widget on the page: the top bar's
 * two-letter code — the only place the layout carries one — or the shared
 * default. The store types `topBar` as a generic block.
 */
export const useLipscoreCode = () => {
	// Not every template's store fork has `topBar` (gotaplatsensfoto's does
	// not), so it is read as optional rather than assumed.
	const appStore = useAppStore() as { topBar?: unknown };

	return computed<string>(() =>
		resolveLipscoreCountry(
			(appStore.topBar as Partial<TopBar> | null | undefined)?.lipscore_code
		)
	);
};
